// extracted by mini-css-extract-plugin
export default {"container":"ErrorScreen_container__KthiR","retryButton":"ErrorScreen_retryButton__TblHp","wrapper":"ErrorScreen_wrapper__4tUNj"};